import YFormOrganizationUsersList from './OrganizationUsersList';

export { YFormOrganizationUsersList };
export default YFormOrganizationUsersList;
